import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en'
import './assets/style/index.scss'
import App from './App.vue'
// 5.引入路由
import router from './router/index'

Vue.use(ElementUI, {locale});
import store from './store/index'

Vue.config.productionTip = false

new Vue({
  // 6.注册路由
  router,
  store,
  render: h => h(App),
  beforeCreate() {
    console.log('Before creating app...');
    // 手机端
    function setRem() {
      var whdef = 100 / 750; // 表示750的设计图,使用100PX的默认值
      var bodyWidth = document.documentElement.clientWidth || document.body.clientWidth; // 当前窗口的宽度
      var rem = bodyWidth * whdef; // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
      document.documentElement.style.fontSize = rem + 'px';
    }
    // pc端
    function setRemPC() {
      var whdef = 100 / 1920; // 表示1920的设计图,使用100PX的默认值
      var bodyWidth = document.documentElement.clientWidth || document.body.clientWidth; // 当前窗口的宽度
      var rem = bodyWidth * whdef; // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
      document.documentElement.style.fontSize = rem + 'px';
    }

    // 实例创建完成后被立即调用rem换算方法,解决内容闪现问题
    if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
      setRem()
      window.addEventListener('resize', setRem); // 浏览器窗口大小改变时调用rem换算方法
    } else {
      setRemPC()  
      window.addEventListener('resize', setRemPC); // 浏览器窗口大小改变时调用rem换算方法
    }
  }
}).$mount('#app')
